module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('c-view', [_c('c-page', [_c('c-navbar'), _vm._v(" "), _c('c-tab', {
    attrs: {
      "tab-items": _vm.tabItems
    },
    on: {
      "itemClick": _vm.itemClickHandler
    }
  }), _vm._v(" "), _c('c-content', [(_vm.ticketList.length > 0) ? _c('div', {
    staticClass: "tickets"
  }, _vm._l((_vm.ticketList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "ticket",
      class: [_vm.ticketPrimary ? 'primary' : '']
    }, [_c('div', {
      staticClass: "part-1"
    }, [_c('p', {
      staticClass: "price"
    }, [_c('sup', [_vm._v("￥")]), _vm._v("\n              " + _vm._s(item.price) + "\n            ")])]), _vm._v(" "), _c('div', {
      staticClass: "line"
    }), _vm._v(" "), _c('div', {
      staticClass: "part-2"
    }, [_c('div', {
      staticClass: "info"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('ul', {
      staticClass: "desc"
    }, _vm._l((item.descs), function(desc) {
      return _c('li', [_vm._v(_vm._s(desc))])
    }))])])])
  })) : _c('div', {
    staticClass: "empty"
  }, [_vm._v("\n        暂无礼金券\n      ")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-026c3ee4","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/about-me/ticket-detail/index.vue
// module id = 1011
// module chunks = 2